var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGhs02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "BRANDFARLIG 02",
  viewBox: "0 0 567 567",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m25 288.89 264 264 264-264-264-264Z",
  style: {
    fill: "#fff"
  },
  transform: "translate(-6 -4.89)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m148 146.89-142 142 142 141 141 142 142-142 142-141-142-142-142-142Zm261 22 119 120-119 119-120 119-119-119-119-119 119-120 119-119Z",
  style: {
    fill: "red"
  },
  transform: "translate(-6 -4.89)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M284 115c-18 34 3 53-20 102-13-10-6-47-30-48 3 12 1 16 0 20-3 17-8 31 3 52-17-8-18-23-32-33 3 16-4 49 15 81-17-2-23-8-41-26 19 100 34 103 105 109-6-1-42-7-55-48 0-10-1 9 34 10-22-35-16-28-14-48 10 13 2 15 27 25-8-26 13-43 8-73 6 13 26 11 25 73 17-19 18-6 26-26 1 11 6 25-17 49 6 2 16 3 31-8-15 18-1 18-40 46 49 1 81-30 80-97-2 6-3 18-29 21 16-16 25-49 12-75-5 4-12 24-29 29 8-14 6-32 6-32s3-25-12-45c-4 30-4 46-23 50 3-17 4-26-6-46-10-21-22-42-24-62m-81 274v18h171v-18Z"
})));
export default SvgGhs02;